import {
  ApiBlueprint,
  configApiRef,
  createApiRef,
  discoveryApiRef,
  oauthRequestApiRef,
  type BackstageIdentityApi,
  type ConfigApi,
  type OpenIdConnectApi,
  type ProfileInfoApi,
  type SessionApi,
} from '@backstage/frontend-plugin-api';
import { OAuth2 } from '@backstage/core-app-api';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';

export const keycloakAuthApiRef = createApiRef<
  OpenIdConnectApi & ProfileInfoApi & BackstageIdentityApi & SessionApi
>({
  id: 'c4ci.auth.keycloak',
});

export function getKeycloakAuthEnvironment(
  configApi: Pick<ConfigApi, 'getOptionalString'>,
): string {
  return configApi.getOptionalString('auth.environment') ?? 'development';
}

export const keycloakAuthApiExtension = ApiBlueprint.make({
  name: 'c4ci-keycloak-auth',
  params: defineParams =>
    defineParams({
      api: keycloakAuthApiRef,
      deps: {
        configApi: configApiRef,
        discoveryApi: discoveryApiRef,
        oauthRequestApi: oauthRequestApiRef,
      },
      factory: ({ configApi, discoveryApi, oauthRequestApi }) =>
        OAuth2.create({
          configApi,
          discoveryApi,
          environment: getKeycloakAuthEnvironment(configApi),
          oauthRequestApi,
          defaultScopes: ['openid', 'profile', 'email'],
          provider: {
            id: 'oidc',
            title: 'C4CI Account',
            icon: AccountCircleIcon,
          },
        }),
    }),
});
